module.exports = __webpack_public_path__ + "static/media/Signal1.d15286c3.png";